import mutations from './mutations';
import actions from './actions';
import getters from './getters';
const User = {
    namespaced: true,
    //state:{
    //    name : 'Aji Ari Adam',
    //    username : 'master',
    //    email : "aji@master.com",
    //    photo : 'https://raw.githubusercontent.com/arindyproject/latihan_vue3/main/src/json_test/277439829_172114501816815_7261629511784878264_n.jpg'
    //},
    state : {},
    mutations,
    actions,
    getters
}

export default User;